import React, { memo } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const ADYEN_FORM_STYLES = `
  #adyen-payment-container .adyen-checkout,
  #adyen-payment-container .adyen-checkout__card,
  #adyen-payment-container .adyen-checkout__payment-method,
  #adyen-payment-container .adyen-checkout__payment-method-wrapper {
    background: transparent !important;
    box-shadow: none !important;
    border: 0 !important;
  }

  #adyen-payment-container .adyen-checkout__payment-method {
    padding: 0 !important;
  }

  #adyen-payment-container .adyen-checkout__payment-method__header {
    padding: 0 0 12px 0 !important;
    border: 0 !important;
  }

  #adyen-payment-container .adyen-checkout__input-wrapper,
  #adyen-payment-container .adyen-checkout__card__holderName__input {
    min-height: 54px !important;
    border-radius: 4px !important;
    border: 1px solid rgba(61, 61, 61, 0.3) !important;
    background: #ffffff !important;
    box-shadow: none !important;
  }

  #adyen-payment-container .adyen-checkout__input-wrapper--focus,
  #adyen-payment-container .adyen-checkout__card__holderName__input:focus-within {
    border-color: #FF8A00 !important;
    box-shadow: 0 0 0 3px rgba(255, 138, 0, 0.12) !important;
  }

  #adyen-payment-container .adyen-checkout__button,
  #adyen-payment-container .adyen-checkout__pay-button {
    display: none !important;
  }

  /* Localhost Checkout proxies Adyen on the page origin. The SDK can leave
     the card form in its loading wrapper even after the iframes configure. */
  #adyen-payment-container .loading-input__spinner {
    display: none !important;
  }

  #adyen-payment-container .loading-input__form--loading {
    opacity: 1 !important;
    pointer-events: auto !important;
  }
`;

const AdyenCardForm = ({ dropinContainerId, loading, visible, status }) => (
  <Box
    sx={{
      position: "relative",
      mt: 2,
      display: visible ? "block" : "none",
    }}
  >
    {status && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1, textAlign: "left" }}
      >
        {status}
      </Typography>
    )}
    <style>{ADYEN_FORM_STYLES}</style>
    <Box
      id={dropinContainerId}
      sx={{
        minHeight: 280,
        width: "100%",
      }}
    />
    {loading && (
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 10,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderRadius: 1,
        }}
      >
        <CircularProgress size={24} color="primary" />
        <Typography variant="body2" color="text.secondary">
          Loading payment form...
        </Typography>
      </Box>
    )}
  </Box>
);

export default memo(AdyenCardForm);
